import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavController } from '@ionic/angular/standalone';
import { TranslatePipe, _ } from '@ngx-translate/core';
import { LoaderComponent } from 'src/app/components/loader/loader.component';
import { SizeGuideEditorFormComponent } from 'src/app/components/size-guide-editor-form/size-guide-editor-form.component';
import { SizeGuide } from '../../../../models/size-guide';
import { SizeGuideService } from '../../../../services/size-guide.service';
import { ToastService } from '../../../../services/toast.service';
import { LoadingUtils } from '../../../../utils/loading.utils';

@Component({
    selector: 'app-profile-tab-size-guide',
    templateUrl: './profile-tab-size-guide.component.html',
    styleUrls: ['./profile-tab-size-guide.component.scss'],
    imports: [CommonModule, TranslatePipe, LoaderComponent, SizeGuideEditorFormComponent],
})
export class ProfileTabSizeGuideComponent implements OnInit {
    @ViewChild(SizeGuideEditorFormComponent) editor: SizeGuideEditorFormComponent;

    sizeGuide: SizeGuide | null = null;
    loading = true;
    catalogLoading = true;

    constructor(
        private readonly sizeGuideService: SizeGuideService,
        private readonly navCtrl: NavController,
        private readonly route: ActivatedRoute,
        private readonly toastService: ToastService,
    ) {}

    ngOnInit() {
        const id = this.route.snapshot.paramMap.get('id');
        if (id) {
            this.sizeGuideService.get(parseInt(id, 10)).subscribe({
                next: (sizeGuide) => {
                    this.sizeGuide = sizeGuide;
                    this.loading = false;
                },
                error: () => {
                    this.loading = false;
                    this.toastService.error(_('An error occurred'));
                },
            });
        } else {
            this.sizeGuide = null;
            this.loading = false;
        }
    }

    async save() {
        if (!this.editor) {
            return;
        }
        this.editor.markTouched();
        const payload = this.editor.getPayload();
        if (!payload) {
            return;
        }
        await LoadingUtils.show();
        const req = this.sizeGuide?.id
            ? this.sizeGuideService.update(this.sizeGuide.id, { name: payload.name, guide: payload.guideJson })
            : this.sizeGuideService.create({ name: payload.name, guide: payload.guideJson });
        req.subscribe({
            next: () => {
                this.navCtrl.navigateBack('/profile/size-guide');
                LoadingUtils.hide();
            },
            error: () => {
                LoadingUtils.hide();
                this.toastService.error(_('An error occurred'));
            },
        });
    }
}
